import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-51ab2288")

_pushScopeId("data-v-51ab2288")
const _hoisted_1 = { class: "OrderPoint__header" }
const _hoisted_2 = { class: "header__title" }
const _hoisted_3 = { class: "OrderPoint__body" }
const _hoisted_4 = { class: "body__name" }
const _hoisted_5 = { class: "body__row" }
const _hoisted_6 = { class: "body__col" }
const _hoisted_7 = { class: "col__text" }
const _hoisted_8 = { class: "col__text" }
const _hoisted_9 = {
  key: 0,
  class: "col__text"
}
const _hoisted_10 = { class: "body__row" }
const _hoisted_11 = { class: "body__col" }
const _hoisted_12 = { class: "col__text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_icon_edit = _resolveComponent("icon-edit")!
  const _component_icon_person = _resolveComponent("icon-person")!
  const _component_icon_location = _resolveComponent("icon-location")!

  return (_openBlock(), _createBlock("div", {
    class: ["OrderPoint", { ftl: _ctx.isFTL, ltl: _ctx.isLTL, blue: _ctx.isExpress }]
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("h2", _hoisted_2, _toDisplayString(_ctx.title), 1),
      (!_ctx.blocked)
        ? (_openBlock(), _createBlock(_component_icon_edit, {
            key: 0,
            class: "header__edit",
            onClick: _ctx.emitReset
          }, null, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("p", _hoisted_4, _toDisplayString(_ctx.point.title), 1),
      _createVNode("div", _hoisted_5, [
        _createVNode(_component_icon_person, { class: "row__icon" }),
        _createVNode("div", _hoisted_6, [
          _createVNode("p", _hoisted_7, _toDisplayString(_ctx.point.full_name), 1),
          _createVNode("p", _hoisted_8, _toDisplayString(_ctx.toPhone(_ctx.point.phone)), 1),
          (Boolean(_ctx.point.additional_phone))
            ? (_openBlock(), _createBlock("p", _hoisted_9, _toDisplayString(_ctx.toPhone(_ctx.point.additional_phone)), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode("div", _hoisted_10, [
        _createVNode(_component_icon_location, { class: "row__icon" }),
        _createVNode("div", _hoisted_11, [
          _createVNode("p", _hoisted_12, _toDisplayString(_ctx.point.full_address), 1)
        ])
      ])
    ])
  ], 2))
})